"use client";

import type { Participant } from "./base-session-template";
import { ActivityDisplayPreview } from "./previews";

export type WalkType = "easy" | "brisk" | "power" | "recovery";

export type WalkingTemplateData = {
  walkType: WalkType;
  distance: number; // km
  time: { hours?: number; minutes: number; seconds: number };
  pace?: string; // min/km
};

export type WalkingParticipant = Participant;

type WalkingDisplayProps = {
  data: WalkingTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function WalkingDisplay({ data, participants }: WalkingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="walking"
      data={data}
      participants={participants}
    />
  );
}
